/* eslint-disable max-lines */
export const globalErrorSchema = {
  scenario: [{
    name: 'appReactGlobalError',
    value: 'Log application global react error',
    activity: [{
      name: 'logError',
      value: 'Log Error Info',
    }],
  }],
};

export const surveySchema = {
  scenario: [{
    name: 'appScenario',
    value: 'Survey App Activity',
    activity: [{
      name: 'appActivity',
      value: 'Survey Activity logger',
    }],
  }],
};

export const instrumentationSchemas = {
  scenario: [{
    name: 'overreactRequest',
    value: 'MCA Overreact Request',
    activity: [{
      name: 'logger',
      value: 'MCA Overreact Request logger',
    }],
  }, {
    name: 'defaultScenario',
    value: 'MCA Default Scenario',
    activity: [{
      name: 'logger',
      value: 'MCA default logger of default scenario',
    }],
  },
  {
    name: 'newPost',
    value: 'MCA new post',
    activity: [{
      name: 'createNewPost',
      value: 'create new post',
    },
    {
      name: 'updatePost',
      value: 'edit an existing post',
    },
    {
      name: 'updateMedia',
      value: 'update a selected media',
    },
    {
      name: 'urlPreview',
      value: 'url preview',
    },
    {
      name: 'socialPost',
      value: 'social post',
    }],
  },
  {
    name: 'conversation',
    value: 'MCA conversationPane',
    activity: [{
      name: 'reply',
      value: 'reply an activity in conversation pane',
    }, {
      name: 'delete',
      value: 'delete an activity in conversation pane',
    }, {
      name: 'update',
      value: 'update options for an activity in conversation pane',
    }, {
      name: 'retweet',
      value: 'retweet an activity in conversation pane',
    }, {
      name: 'render',
      value: 'render row in conversation pane',
    }],
  },
  {
    name: 'businessDetails',
    value: 'businessDetails',
    activity: [{
      name: 'addGeoInfo',
      value: 'add Geo Info',
    }],
  },
  {
    name: 'browserExtension',
    value: 'browserExtension',
    activity: [{
      name: 'tagTest',
      value: 'tagTest',
    }],
  },
  {
    name: 'locationTargetValidation',
    value: 'locationTargetValidation',
    activity: [{
      name: 'getRedundantTargets',
      value: 'getRedundantTargets',
    }],
  },
  {
    name: 'omnichannelChat',
    value: 'omnichannelChat',
    activity: [{
      name: 'sdkEvent',
      value: 'omnichannelChatSDKEvent',
    }, {
      name: 'chatBubble',
      value: 'chatBubble',
    }],
  },
  {
    name: 'campaignList',
    value: 'MCA campaignList',
    activity: [{
      name: 'readCampaigns',
      value: 'read campaigns',
    }],
  },
  {
    name: 'adTypeSelectionStep',
    value: 'adTypeSelectionStep',
    activity: [{
      name: 'updateCampaign',
      value: 'updateCampaign',
    }, {
      name: 'fetchAccountCountryCode',
      value: 'fetchAccountCountryCode',
    }, {
      name: 'updateAccount',
      value: 'updateAccount',
    }, {
      name: 'initFbSdk',
      value: 'initFbSdk',
    }],
  },
  {
    name: 'keywordThemesStep',
    value: 'keywordThemesStep',
    activity: [{
      name: 'updateCampaign',
      value: 'updateCampaign',
    }, {
      name: 'keywordAutoComplete',
      value: 'keywordAutoComplete',
    }, {
      name: 'keywordProductServiceRecommendations',
      value: 'keywordProductServiceRecommendations',
    }],
  },
  {
    name: 'accountInfoStep',
    value: 'accountInfoStep',
    activity: [{
      name: 'uiInteraction',
      value: 'UI interaction',
    }, {
      name: 'updateCountryCodeLink',
      value: 'User navigate back to update country code',
    }],
  },
  {
    name: 'paymentStep',
    value: 'paymentStep',
    activity: [{
      name: 'associateAndRedeemCoupon',
      value: 'associate coupon to account and redeem',
    },
    {
      name: 'readAccount',
      value: 'read account',
    },
    {
      name: 'readCountries',
      value: 'read Countries',
    },
    {
      name: 'readCurrencies',
      value: 'read Currencies',
    },
    {
      name: 'readOfflinePaymentInstructions',
      value: 'read offline payment instructions',
    },
    {
      name: 'readPaymentContext',
      value: 'read payment context',
    },
    {
      name: 'readPaymentInstruments',
      value: 'read payment instruments',
    },
    {
      name: 'readStates',
      value: 'read states',
    },
    {
      name: 'readTaxes',
      value: 'read taxes',
    },
    {
      name: 'readTopUpLimit',
      value: 'read top up limit',
    },
    {
      name: 'uiInteraction',
      value: 'UI interaction',
    },
    {
      name: 'updateAccount',
      value: 'update account',
    }],
  },
  {
    name: 'addFundsStep',
    value: 'addFundsStep',
    activity: [{
      name: 'readAccount',
      value: 'read account',
    },
    {
      name: 'readPaymentInstrument',
      value: 'read payment instrument',
    },
    {
      name: 'readTaxes',
      value: 'read taxes',
    },
    {
      name: 'readTopUpLimit',
      value: 'read top up limit',
    },
    {
      name: 'uiInteraction',
      value: 'UI interaction',
    }],
  },
  {
    name: 'budget',
    value: 'MCA budget',
    activity: [{
      name: 'readCampaign',
      value: 'read campaign',
    },
    {
      name: 'readTargets',
      value: 'read targets',
    },
    {
      name: 'readAds',
      value: 'read ads',
    },
    {
      name: 'updateCampaign',
      value: 'update campaign',
    },
    {
      name: 'getBudgetSuggestions',
      value: 'Get budget suggestions',
    },
    {
      name: 'budgetInputChanged',
      value: 'buget input changed',
    },
    {
      name: 'budgetSliderChanged',
      value: 'budget slider changed',
    },
    {
      name: 'budgetInitialized',
      value: 'budget initialzed',
    },
    {
      name: 'currencySaved',
      value: 'currency saved',
    },
    {
      name: 'budgetLandscape',
      value: 'budgetLandscape',
    }, {
      name: 'saveBudget',
      value: 'save budget',
    }],
  },
  {
    name: 'draftCampaigns',
    value: 'MCA draftCampaigns',
    activity: [{
      name: 'deleteCampaign',
      value: 'delete campaigns',
    }],
  },
  {
    name: 'wizard',
    value: 'MCA wizard',
    activity: [{
      name: 'customerAccountUserSignup',
      value: 'sign up customer account user',
    },
    {
      name: 'createCampaign',
      value: 'create campaign',
    },
    {
      name: 'readCampaign',
      value: 'read campaign according to campaignId',
    },
    {
      name: 'readTargets',
      value: 'read targets according to campaignId',
    },
    {
      name: 'deleteCampaign',
      value: 'delete campaign according to campaignId',
    },
    {
      name: 'updateCampaign',
      value: 'update campaign according to campaignId',
    },
    {
      name: 'readCampaigns',
      value: 'read all campaigns',
    },
    {
      name: 'readChannelProfiles',
      value: 'read channel profiles',
    },
    {
      name: 'readSocialProfiles',
      value: 'read social profiles',
    },
    {
      name: 'readPaymentInstruments',
      value: 'read payment instruments',
    },
    {
      name: 'updateAccount',
      value: 'update account',
    },
    {
      name: 'readAccount',
      value: 'read account',
    },
    {
      name: 'updateCustomer',
      value: 'update customer',
    },
    {
      name: 'readCustomer',
      value: 'read customer',
    },
    {
      name: 'associateProfile',
      value: 'associate social profile to campaign',
    },
    {
      name: 'disassociateProfile',
      value: 'disassociate social profile from campaign',
    },
    {
      name: 'readUser',
      value: 'read User',
    },
    {
      name: 'updateUser',
      value: 'update User',
    },
    {
      name: 'readTermsAndCondition',
      value: 'read TermsAndCondition',
    },
    {
      name: 'createSocialProfiles',
      value: 'create SocialProfiles',
    },
    {
      name: 'readInternalChannel',
      value: 'read internal channel',
    },
    {
      name: 'updateInternalChannel',
      value: 'update internal channel',
    },
    {
      name: 'readCountries',
      value: 'read Countries',
    },
    {
      name: 'readCurrencies',
      value: 'read Currencies',
    },
    {
      name: 'readOfflinePaymentInstructions',
      value: 'read offline payment instructions',
    },
    {
      name: 'readTaxes',
      value: 'read taxes',
    },
    {
      name: 'readTopUpLimit',
      value: 'read top up limit',
    },
    {
      name: 'readTimeZones',
      value: 'read TimeZones',
    },
    {
      name: 'readCurrencyCountriesMappings',
      value: 'read CurrencyCountriesMappings',
    },
    {
      name: 'readStates',
      value: 'read States',
    },
    {
      name: 'cancelDialog',
      value: 'cancelDialog',
    },
    {
      name: 'wizardStepInteraction',
      value: 'wizard step interaction data',
    },
    {
      name: 'wizardBlocking',
      value: 'wizardBlocking',
    },
    {
      name: 'requestsState',
      value: 'wizard requests sequence state',
    },
    {
      name: 'validateAddress',
      value: 'validate Address',
    },
    {
      name: 'uiInteraction',
      value: 'UI interaction',
    },
    {
      name: 'qualtrics',
      value: 'call qualtrics API',
    },
    {
      name: 'associateCoupon',
      value: 'associate coupon to account',
    },
    {
      name: 'associateAndRedeemCoupon',
      value: 'associate coupon to account and redeem',
    },
    {
      name: 'upPromotionalOfferCoupon',
      value: 'UP promotional offer coupon info',
    },
    {
      name: 'readPaymentContext',
      value: 'read payment context',
    },
    {
      name: 'readAds',
      value: 'read ads',
    },
    {
      name: 'defaultBusinessInfo',
      value: 'default business info',
    },
    {
      name: 'switchToExpert',
      value: 'switch to expert',
    },
    {
      name: 'stepWizardSM',
      value: 'step wizard state machine',
    },
    {
      name: 'surveyActivity',
      value: 'Survey Activity',
    }],
  },
  {
    name: 'home',
    value: 'Home page',
    activity: [{
      name: 'upPromotionalOfferCoupon',
      value: 'UP promotional offer coupon info',
    }],
  },
  {
    name: 'upAudienceTargetingPanel',
    value: 'upAudienceTargetingPanel',
    activity: [{
      name: 'validateTargets',
      value: 'validateTargets',
    }],
  },
  {
    name: 'useSmartPageFetcher',
    value: 'useSmartPageFetcher',
    activity: [{
      name: 'readPage',
      value: 'readPage',
    }],
  },
  {
    name: 'singleCampaign',
    value: 'MCA single campaign',
    activity: [{
      name: 'readCampaign',
      value: 'read campaign according to campaignId',
    },
    {
      name: 'readCampaignPerfMetrics',
      value: 'read campaign performance metrics according to campaignId',
    },
    {
      name: 'updateCampaign',
      value: 'update campaign data',
    },
    {
      name: 'qualtrics',
      value: 'call qualtrics API',
    },
    {
      name: 'surveyActivity',
      value: 'Survey Activity',
    },
    {
      name: 'connectExpert',
      value: 'connectExpert',
    },
    {
      name: 'readTargets',
      value: 'readTargets',
    },
    {
      name: 'editAds',
      value: 'editAds',
    }],
  },
  {
    name: 'allCampaigns',
    value: 'MCA all campaigns',
    activity: [{
      name: 'readCampaign',
      value: 'read all campaigns',
    },
    {
      name: 'readCampaignPerfMetrics',
      value: 'read campaign performance metrics aggregated for all campaigns',
    },
    {
      name: 'readDisapprovedCampaigns',
      value: 'read disapproved campaigns',
    }],
  },
  {
    name: 'usageReport',
    value: 'usageReport of MCA',
    activity: [{
      name: 'mainBundleLogin',
      value: 'login mca main bundle',
    },
    {
      name: 'signUpBundleLogin',
      value: 'login mca sign up bundle',
    },
    {
      name: 'signUpBundleResume',
      value: 'resume mca sign up bundle',
    },
    {
      name: 'pageInteraction',
      value: 'page interaction data',
    },
    {
      name: 'tabUsage',
      value: 'change the active tab',
    },
    {
      name: 'panelUsage',
      value: 'usage data of panel',
    },
    {
      name: 'upWizardPanelUsage',
      value: 'upWizardPanelUsage',
    },
    {
      name: 'prefillUsage',
      value: 'upWizardTileUsage',
    },
    {
      name: 'upValidation',
      value: 'upValidation',
    }],
  },
  {
    name: 'searchPhrases',
    value: 'MCA Search Phrases',
    activity: [{
      name: 'openManageAllPanel',
      value: 'open manage all side panel',
    }],
  },
  {
    name: 'socialProfiles',
    value: 'MCA social profile and ad account settings',
    activity: [{
      name: 'linkSocialProfile',
      value: 'linkSocialProfile',
    },
    {
      name: 'linkChannelProfile',
      value: 'linkChannelProfile',
    },
    {
      name: 'authPopupWindow',
      value: 'authPopupWindow',
    }],
  },
  {
    name: 'chat',
    value: 'MCA private chat',
    activity: [{
      name: 'render',
      value: 'render row in private chat',
    }],
  },
  {
    name: 'locationTargets',
    value: 'read and write campaign location targets',
    activity: [{
      name: 'locationSearch',
      value: 'locationSearch',
    },
    {
      name: 'readLocationTargets',
      value: 'readLocationTargets',
    },
    {
      name: 'writeLocationTargets',
      value: 'writeLocationTargets',
    }],
  },
  {
    name: 'inbox',
    value: 'operations on inbox page',
    activity: [{
      name: 'update',
      value: 'update the activity in inbox page',
    }, {
      name: 'render',
      value: 'render the activity in inbox page',
    }],
  },
  {
    name: 'draft',
    value: 'operations on draft page',
    activity: [{
      name: 'delete',
      value: 'delete the post in draft page',
    }],
  },
  {
    name: 'published',
    value: 'operations on published page',
    activity: [{
      name: 'delete',
      value: 'delete the activity in published page',
    }],
  },
  {
    name: 'useLocationEditorData',
    value: 'useLocationEditorData',
    activity: [{
      name: 'readTargets',
      value: 'readTargets',
    }],
  },
  {
    name: 'scheduled',
    value: 'operations on scheduled page',
    activity: [{
      name: 'delete',
      value: 'delete  the activity in scheduled page',
    }],
  },
  {
    name: 'criticalNotification',
    value: 'critical notification',
    activity: [{
      name: 'adBlocker',
      value: 'ad blocker detection',
    }, {
      name: 'subscriptionAds',
      value: 'subscription ads status',
    }],
  },
  {
    name: 'ads',
    value: 'ads',
    activity: [{
      name: 'createTextAd',
      value: 'create text ad',
    },
    {
      name: 'deleteTextAd',
      value: 'delete text ad',
    },
    {
      name: 'updateTextAd',
      value: 'update text ad',
    },
    {
      name: 'createImageAd',
      value: 'create image ad',
    },
    {
      name: 'deleteImageAd',
      value: 'delete image ad',
    },
    {
      name: 'updateImageAd',
      value: 'update image ad',
    },
    {
      name: 'createVideoAd',
      value: 'create video ad',
    },
    {
      name: 'updateVideoAd',
      value: 'update video ad',
    },
    {
      name: 'socialAdsSection',
      value: 'socialAdsSection',
    },
    {
      name: 'deleteVideoAd',
      value: 'delete video ad',
    }],
  },
  {
    name: 'adEditorial',
    value: 'adEditorial',
    activity: [{
      name: 'requestException',
      value: 'requestException',
    }, {
      name: 'handleEditorial',
      value: 'handleEditorial',
    }, {
      name: 'showEditorial',
      value: 'showEditorial',
    }],
  },
  {
    name: 'specialCategory',
    value: 'specialCategory',
    activity: [{
      name: 'messageBar',
      value: 'messageBar',
    }, {
      name: 'settingBanner',
      value: 'settingBanner',
    }],
  },
  {
    name: 'inlineHelp',
    value: 'inlineHelp',
    activity: [{
      name: 'inlineHelp',
      value: 'inlineHelp',
    }],
  },
  {
    name: 'severErrorMapping',
    value: 'severErrorMapping',
    activity: [{
      name: 'errorMap',
      value: 'errorMap',
    }],
  },
  {
    name: 'meControl',
    value: 'meControl',
    activity: [{
      name: 'signOut',
      value: 'signOut',
    },
    {
      name: 'qualtrics',
      value: 'call qualtrics API',
    }],
  },
  {
    name: 'adSuggestionGallery',
    value: 'adSuggestionGallery',
    activity: [{
      name: 'viewSuggestion',
      value: 'viewSuggestion',
    },
    {
      name: 'nextPageClick',
      value: 'nextPageClick',
    },
    {
      name: 'previousPageClick',
      value: 'previousPageClick',
    },
    {
      name: 'pageSizeChange',
      value: 'pageSizeChange',
    },
    {
      name: 'applySuggestion',
      value: 'applySuggestion',
    },
    {
      name: 'editSuggestion',
      value: 'editSuggestion',
    },
    {
      name: 'dismissSuggestion',
      value: 'dismissSuggestion',
    },
    {
      name: 'dismissAllSuggestions',
      value: 'dismissAllSuggestions',
    }],
  },
  {
    name: 'conversionTracking',
    value: 'DMC conversion tracking',
    activity: [
      {
        name: 'conversionTracking',
        value: 'conversionTracking',
      },
    ],
  },
  {
    name: 'extractBusinessInfo',
    value: 'extract business information from website',
    activity: [
      {
        name: 'extractBusinessInfo',
        value: 'extractBusinessInfo',
      },
    ],
  },
  {
    name: 'myWebsite',
    value: 'Build my website',
    activity: [{
      name: 'readMyWebsiteButton',
      value: 'readMyWebsiteButton',
    },
    {
      name: 'clickMyWebsiteButton',
      value: 'clickMyWebsiteButton',
    },
    {
      name: 'readBuildMyWebsiteCallout',
      value: 'readBuildMyWebsiteCallout',
    },
    {
      name: 'clickBuildMyWebsiteCalloutButton',
      value: 'clickBuildMyWebsiteCalloutButton',
    }],
  },
  {
    name: 'appPreloadScenario',
    value: 'app preload',
    activity: [
      {
        name: 'appPreload',
        value: 'app preload',
      },
    ],
  },
  {
    name: 'signupFlowScenario',
    value: 'signup flow',
    activity: [
      {
        name: 'signupFlow',
        value: 'signup flow',
      },
    ],
  },
  {
    name: 'customerJourneyScenario',
    value: 'customer journey',
    activity: [
      {
        name: 'customerJourney',
        value: 'customer journey',
      },
    ],
  },
  {
    name: 'feedbackScenario',
    value: 'feedback scenario',
    activity: [
      {
        name: 'feedbackActivity',
        value: 'feedback activity',
      },
    ],
  },
  {
    name: 'globalMenuScenario',
    value: 'global menu scenario',
    activity: [
      {
        name: 'globalMenuActivity',
        value: 'global menu activity',
      },
    ],
  },
  {
    name: 'upSupportScenario',
    value: 'up support',
    activity: [
      {
        name: 'upSupportIntroduction',
        value: 'up support introduction',
      },
    ],
  },
  {
    name: 'upLandingPage',
    value: 'upLandingPage',
    activity: [{
      name: 'uiActivity',
      value: 'uiActivity',
    }],
  },
  {
    name: 'subAdsLanding',
    value: 'subAdsLanding',
    activity: [{
      name: 'logger',
      value: 'logger',
    }],
  },
  {
    name: 'subscriptionAds',
    value: 'subscriptionAds',
    activity: [{
      name: 'subAdsRedirection',
      value: 'subAdsRedirection',
    },
    {
      name: 'subAdsStatus',
      value: 'subAdsStatus',
    },
    {
      name: 'subAdsUpdateWebsite',
      value: 'subAdsUpdateWebsite',
    },
    {
      name: 'subAdsUpdateChannel',
      value: 'subAdsUpdateChannel',
    }],
  },
  {
    name: 'subscriptionAdsWizard',
    value: 'subscriptionAdsWizard',
    activity: [{
      name: 'associateAndRedeemCoupon',
      value: 'associate coupon to account and redeem',
    },
    {
      name: 'readAccount',
      value: 'read account',
    },
    {
      name: 'readCountries',
      value: 'read Countries',
    },
    {
      name: 'readCurrencies',
      value: 'read Currencies',
    },
    {
      name: 'readOfflinePaymentInstructions',
      value: 'read offline payment instructions',
    },
    {
      name: 'readPaymentContext',
      value: 'read payment context',
    },
    {
      name: 'readPaymentInstruments',
      value: 'read payment instruments',
    },
    {
      name: 'readStates',
      value: 'read states',
    },
    {
      name: 'readTaxes',
      value: 'read taxes',
    },
    {
      name: 'readTopUpLimit',
      value: 'read top up limit',
    },
    {
      name: 'requestsState',
      value: 'wizard requests sequence state',
    },
    {
      name: 'setTermsAndCondition',
      value: 'set TermsAndCondition',
    },
    {
      name: 'uiInteraction',
      value: 'UI interaction',
    },
    {
      name: 'updateAccount',
      value: 'update account',
    },
    {
      name: 'upPromotionalOfferCoupon',
      value: 'promotional offer coupon info',
    },
    {
      name: 'wizardInitialization',
      value: 'wizard initialization',
    },
    {
      name: 'wizardStepInteraction',
      value: 'wizard step interaction',
    },
    {
      name: 'websiteStep',
      value: 'website step',
    },
    {
      name: 'adPreviewsTile',
      value: 'ad previews tile',
    }],
  },
  {
    name: 'getScheduledPostsScenario',
    value: 'get scheduled posts scenario',
    activity: [
      {
        name: 'getScheduledPostsActivity',
        value: 'get scheduled posts activity',
      },
    ],
  },
  {
    name: 'budgetLandscape',
    value: 'get budgetLandscape scenario',
    activity: [
      {
        name: 'getBudgetLandscapeCampaignIdsActivity',
        value: 'get budget landscape campaign ids activity',
      },
    ],
  },
  {
    name: 'imageExperienceScenario',
    value: 'image experience',
    activity: [
      {
        name: 'imageUploader',
        value: 'image uploader',
      },
      {
        name: 'stockImage',
        value: 'stock image',
      },
    ],
  },
  {
    name: 'm365IntegrationScenario',
    value: 'M365 integration',
    activity: [
      {
        name: 'usageReport',
        value: 'M365 integration usage report',
      },
    ],
  },
  {
    name: 'facebookAdAccountScenario',
    value: 'facebookAdAccountScenario',
    activity: [{
      name: 'facebookAdAccount',
      value: 'facebookAdAccount',
    }],
  },
  {
    name: 'localeAndMarketContext',
    value: 'localeAndMarketContext',
    activity: [{
      name: 'localeAndMarketContext',
      value: 'localeAndMarketContext',
    }],
  },
  {
    name: 'draftCurrency',
    value: 'draftCurrency',
    activity: [{
      name: 'saveDraftCurrency',
      value: 'saveDraftCurrency',
    }],
  },
  {
    name: 'currencyCountry',
    value: 'currencyCountry',
    activity: [{
      name: 'fetchCurrencyCountryMapping',
      value: 'fetchCurrencyCountryMapping',
    }],
  },
  {
    name: 'couponCurrency',
    value: 'couponCurrency',
    activity: [{
      name: 'couponCurrency',
      value: 'couponCurrency',
    }],
  },
  {
    name: 'changeHistory',
    value: 'changeHistory',
    activity: [{
      name: 'changeHistory',
      value: 'changeHistory',
    }],
  },
  {
    name: 'sideNavigation',
    value: 'sideNavigation',
    activity: [{
      name: 'uiInteraction',
      value: 'uiInteraction',
    }, {
      name: 'switchToExpert',
      value: 'switchToExpert',
    }],
  },
  {
    name: 'createCampaignManually',
    value: 'createCampaignManually',
    activity: [{
      name: 'modal',
      value: 'modal',
    }],
  },
  {
    name: 'streamlineSignUp',
    value: 'streamlineSignUp',
    activity: [
      {
        name: 'streamlineSignUpFloatingHelp',
        value: 'streamlineSignUpFloatingHelp',
      }, {
        name: 'streamlineSignUpWizard',
        value: 'streamlineSignUpWizard',
      }, {
        name: 'upPromotionalOfferCoupon',
        value: 'upPromotionalOfferCoupon',
      },
    ],
  },
  {
    name: 'msanAdsScenario',
    value: 'msanAdsScenario',
    activity: [{
      name: 'initImages',
      value: 'initImages',
    }, {
      name: 'formatImages',
      values: 'formatImages',
    }],
  }, {
    name: 'streamlinedSignUpAds',
    value: 'streamlinedSignUpAds',
    activity: [
      {
        name: 'loadAds',
        value: 'loadAds',
      },
      {
        name: 'saveAds',
        value: 'saveAds',
      },
    ],
  }],
};
